import React from 'react';
import { CheckIcon } from 'lucide-react';
import { ProcessSteps } from '../components/ProcessSteps';
import { Button } from '../components/Button';
export function HowItWorksPage() {
  return <main className="w-full" data-id="element-526">
      {/* Hero Section */}
      <section className="w-full bg-gradient-to-br from-[#07493a] to-[#1a6b55] py-20 px-4" data-id="element-527">
        <div className="max-w-7xl mx-auto text-center" data-id="element-528">
          <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-529">
            How It Works
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-530">
            Our streamlined process makes accessing your home equity simple,
            fast, and stress-free.
          </p>
        </div>
      </section>

      {/* Process Steps */}
      <ProcessSteps data-id="element-531" />

      {/* Detailed Explanation */}
      <section className="w-full bg-cream py-20 px-4" data-id="element-532">
        <div className="max-w-4xl mx-auto" data-id="element-533">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-12 text-center" data-id="element-534">
            What Makes Us Different
          </h2>

          <div className="space-y-8" data-id="element-535">
            <div className="bg-white rounded-xl p-8 shadow-sm" data-id="element-536">
              <div className="flex items-start" data-id="element-537">
                <div className="flex-shrink-0 w-8 h-8 bg-primary rounded-full flex items-center justify-center mr-4" data-id="element-538">
                  <CheckIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-539" />
                </div>
                <div data-id="element-540">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-541">
                    No Credit Checks Required
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-542">
                    Unlike traditional lenders, we don't base our decisions on
                    your credit score. Our lending is purely equity-based,
                    meaning your property's value and location are what matter
                    most. This makes our solutions accessible to homeowners
                    regardless of their credit history.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-sm" data-id="element-543">
              <div className="flex items-start" data-id="element-544">
                <div className="flex-shrink-0 w-8 h-8 bg-primary rounded-full flex items-center justify-center mr-4" data-id="element-545">
                  <CheckIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-546" />
                </div>
                <div data-id="element-547">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-548">
                    Fast Approval & Funding
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-549">
                    Our streamlined process means you can receive funds in as
                    little as 48 hours after approval. We understand that when
                    you need access to your equity, time is often of the
                    essence. Our efficient system ensures you get the funds you
                    need quickly.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-sm" data-id="element-550">
              <div className="flex items-start" data-id="element-551">
                <div className="flex-shrink-0 w-8 h-8 bg-primary rounded-full flex items-center justify-center mr-4" data-id="element-552">
                  <CheckIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-553" />
                </div>
                <div data-id="element-554">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-555">
                    Flexible Use of Funds
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-556">
                    There are no restrictions on how you use your home equity.
                    Whether it's for debt consolidation, home renovations,
                    investment opportunities, medical expenses, or any other
                    financial need, the choice is entirely yours.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-sm" data-id="element-557">
              <div className="flex items-start" data-id="element-558">
                <div className="flex-shrink-0 w-8 h-8 bg-primary rounded-full flex items-center justify-center mr-4" data-id="element-559">
                  <CheckIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-560" />
                </div>
                <div data-id="element-561">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-562">
                    Transparent Process
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-563">
                    We believe in complete transparency. From the initial
                    assessment to final funding, you'll know exactly what to
                    expect. No hidden fees, no surprises. Our team is available
                    to answer any questions throughout the entire process.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="w-full relative overflow-hidden bg-gradient-to-br from-[#07493a] to-[#1a6b55] py-20 px-4" data-id="element-564">
        <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse 60% 80% at 80% 20%, rgba(201,169,97,0.15) 0%, rgba(201,169,97,0.06) 40%, transparent 70%)'
      }} aria-hidden="true" data-id="element-565" />
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-566">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-567">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-gray-300 mb-8" data-id="element-568">
            Take the first step towards financial freedom. Get your free
            assessment in minutes.
          </p>
          <Button variant="primary" size="lg" icon href="/#form" data-id="element-569">
            Apply Now
          </Button>
        </div>
      </section>
    </main>;
}